const { appendToUrl } = require('../utils/urlUtil');
const waiNotify = require('../components/waiNotify');
var billingHelpers = require('../checkout/billing');
module.exports = function () {
    const $body = $('body');
    const $cart = $('.js-cart');

    $body.on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        const couponCode = $(this).data('code');
        const uuid = $(this).data('uuid');
        const $deleteConfirmBtn = $('.js-delete-coupon-confirmation-btn');
        const $productToRemoveSpan = $('.js-coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $body.on('click', '.js-delete-coupon-confirmation-btn', function (event) {
        let url = $(this).data('action');
        const uuid = $(this).data('uuid');
        const couponCode = $(this).data('code');

        const urlParams = {
            code: couponCode,
            uuid
        };
        url = appendToUrl(url, urlParams);

        $cart.spinner().start();
        const message = $(event.target).data('action-message');

        $.ajax({
            url,
            type: 'get',
            dataType: 'json',
            success(data) {
                $(`.js-coupon-uuid-${uuid}`).remove();
                $body
                    .trigger('basket:update:totals', data)
                    .trigger('basket:update:discounts', { discounts: data.approachingDiscounts })
                    .trigger('basket:update:promos', data.totals.discountsHtml)
                    .trigger('basket:validate', data)
                    .trigger('coupon:form:clear');
                $('.js-promo-code-form').removeClass('show');
                $cart.spinner().stop();
                waiNotify(message);
                billingHelpers.methods.updateGiftCardContainer(data);
                billingHelpers.methods.updateBillingLook(data);
                var hasRecaptcha = $('#js-g-recaptcha-hpp').length > 0;

                if (hasRecaptcha) {
                    $('body').trigger('checkout:resetRecaptcha');
                }
            },
            error(err) {
                if (err.responseJSON.redirectUrl) {
                    window.window.location.href = err.responseJSON.redirectUrl;
                } else {
                    $body.trigger('basket:notify', err.responseJSON.errorMessage);
                    $cart.spinner().stop();
                }
            }
        });
    });
};
